const production: boolean = true;

export const environment = {
  production: production,
  logo: "/assets/images/logo.png",
  endpoint: "https://ckfunding-api.tech4broker.space/ib1",
  ib_level: 1,
  client_portal_url: "https://client.wallcorefx.com",
  portal_name: "IB",
  logo_width: 150,
  inner_logo_width: 80,
};